import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="container navbar-container">
        <Link to="/" className="navbar-logo">
          OperatorKredytowy.pl
        </Link>
        
        <div className="menu-icon" onClick={toggleMenu}>
          <div className={isMenuOpen ? 'hamburger open' : 'hamburger'}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        
        <ul className={isMenuOpen ? 'nav-menu active' : 'nav-menu'}>
          <li className="nav-item">
            <Link to="/" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              Strona Główna
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/website-structure" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              Struktura Strony
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/website-pricing" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              Wycena Strony
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/facebook-tiktok-ads" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              Facebook/TikTok Ads
            </Link>
          </li>
          <li className="nav-item">
            <Link to="/google-ads" className="nav-link" onClick={() => setIsMenuOpen(false)}>
              Google Ads
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;